import { AUTH_STORAGE_KEYS } from '../constants';
import { deleteCookie } from '../lib/cookies';
import { getMegaModeInfo } from '../lib/tokenProvider';

/**
 * Persistent banner shown while the active session is an megamode token.
 * Lets the admin exit the read-only session and close the tab.
 *
 * Self-contained (reads storage directly, no AuthProvider context) so it can be
 * mounted in the shell AND in micro-apps that use the shared-auth fallback.
 */
export function MegaModeBanner() {
  const megamode = getMegaModeInfo();

  if (!megamode) {
    return null;
  }

  let email = '';
  try {
    const raw =
      localStorage.getItem(AUTH_STORAGE_KEYS.USER) ||
      localStorage.getItem(AUTH_STORAGE_KEYS.USER_DETAILS);
    if (raw) {
      email = JSON.parse(raw)?.email || '';
    }
  } catch {
    email = '';
  }

  const handleExit = () => {
    localStorage.removeItem(AUTH_STORAGE_KEYS.TOKEN);
    localStorage.removeItem(AUTH_STORAGE_KEYS.USER);
    localStorage.removeItem(AUTH_STORAGE_KEYS.USER_DETAILS);
    deleteCookie(AUTH_STORAGE_KEYS.TOKEN);
    deleteCookie(AUTH_STORAGE_KEYS.USER);

    // The tab was opened by the admin app via window.open, so it can close
    // itself. Fall back to the login page if the browser blocks close().
    window.close();
    window.location.href = '/login';
  };

  return (
    <div className="flex h-9 shrink-0 items-center justify-center gap-3 bg-warning px-4 text-sm font-medium text-warning-foreground">
      <span>
        Read-Only MegaMode
        {email ? ` — viewing as ${email}` : ''}
      </span>
      <button
        type="button"
        onClick={handleExit}
        className="rounded border border-warning-foreground/40 px-2 py-0.5 hover:bg-warning-foreground/10"
      >
        Exit MegaMode
      </button>
    </div>
  );
}
